import { defineStore } from "pinia";
import { useStore } from "./getStartStore";

export const useSavedStore = defineStore("saved", {
  state: () => ({
    savedArray: [],
  }),
  actions: {
    getStoredSaved() {
      const startStore = useStore();
      return "saved-" + startStore.startSettings.companyId;
    },

    loadSaved() {
      const startStore = useStore();
      const products = startStore.startSettings.products || [];
      const companyId = this.getStoredSaved();

      this.savedArray = JSON.parse(localStorage.getItem(companyId) || '[]');

      // Створюємо множину для швидкого пошуку ID
      const validIds = new Set(products.map((p) => p.nomenclatureId));

      // Фільтруємо і видаляємо ID, яких немає в validIds
      this.savedArray .forEach((id) => {
        if (!validIds.has(id)) {
          this.removeFromSaved({ nomenclatureId: id });
        }
      });
    },

    addToSaved(dish) {
      const companyId = this.getStoredSaved();
      this.savedArray.push(dish.nomenclatureId);
      localStorage.setItem(companyId, JSON.stringify(this.savedArray));
    },

    removeFromSaved(dish) {
      const companyId = this.getStoredSaved();
      this.savedArray = this.savedArray.filter(
        (id) => id !== dish.nomenclatureId
      );
      localStorage.setItem(companyId, JSON.stringify(this.savedArray));
    },
  },
});
